"use client";

import { IconBook, IconShieldLock, IconUsers } from "@tabler/icons-react";
import type * as React from "react";
import { useAuth } from "@/components/providers/auth";
import { useTeam } from "@/components/providers/team";
import { NavMain } from "@/components/sidebar/nav-main";
import { NavUser } from "@/components/sidebar/nav-user";
import { TeamSwitcher } from "@/components/sidebar/team-switcher";
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarRail,
} from "@/components/ui/sidebar";
import { StandardAppNavigation } from "@/data/navigation/standard-app";
import { isModuleEnabled, isStaffConsoleEnabled } from "@/lib/modules";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
	const { user } = useAuth();
	const { teamID, teams } = useTeam();
	const activeTeam = teams.find((t) => t.id === teamID);
	const isPersonal = activeTeam?.type === "personal";
	const teamSectionTitle =
		!isModuleEnabled("team") && isPersonal ? "Personal" : "Team";

	return (
		<Sidebar collapsible="icon" {...props}>
			<SidebarHeader>
				<TeamSwitcher />
			</SidebarHeader>
			<SidebarContent>
				{isStaffConsoleEnabled() && !!user?.staffRole && (
					<NavMain
						nav={StandardAppNavigation.admin}
						title="Admin"
						icon={IconShieldLock}
					/>
				)}
				<NavMain
					nav={StandardAppNavigation.developer}
					title="Developer"
					icon={IconBook}
				/>
				<NavMain
					nav={StandardAppNavigation.team}
					title={teamSectionTitle}
					icon={IconUsers}
				/>
			</SidebarContent>
			<SidebarFooter>
				<NavUser
					user={{
						firstName: user?.firstName ?? "",
						lastName: user?.lastName ?? "",
						email: user?.email ?? "",
						emoji: user?.emoji ?? "👤",
					}}
				/>
			</SidebarFooter>
			<SidebarRail />
		</Sidebar>
	);
}
